import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

function EditButton({ onClick }) {
  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement='top'
      overlay={
        <Popover className='popover-basic'>
          <Popover.Content>Edit Customer</Popover.Content>
        </Popover>
      }
    >
      <button className='btn btn-link' onClick={onClick}>
        <span className='sr-only'>Edit</span>
        <i className='fas fa-pencil-alt' aria-hidden='true'></i>
      </button>
    </OverlayTrigger>
  );
}

export default EditButton;
